import { render, staticRenderFns } from "./degradability.vue?vue&type=template&id=30719e91&scoped=true"
import script from "./degradability.vue?vue&type=script&lang=js"
export * from "./degradability.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30719e91",
  null
  
)

export default component.exports